import Http from '@/services/http';
import { Loss, LossCalculationRequest } from 'sigma-mappings';
import lossesFieldsDefinitions from '@/domain/data/installation/assetInformation/lossesFieldsDefinitions';
import translate from '@/services/translate';
import { getFormattedNumber } from '@/services/exceptionHelper';

const urls = {
  getLosses: id => `ativo/${id}/transformador/perdas`,
  updateLosses: id => `ativo/${id}/transformador/perdas`,
  calculateLosses: id => `ativo/${id}/transformador/perdas/resultado-calculo`,
};

/* istanbul ignore next */
const error = {
  errorHandling: {
    responseMessageParams: {
      $MA029: (data) => {
        if (!data && !data.parameters) return null;
        const returnedField = lossesFieldsDefinitions[data.field];
        return {
          FaixaInicial: getFormattedNumber(data.parameters[0], returnedField.precision),
          FaixaFinal: getFormattedNumber(data.parameters[1], returnedField.precision),
          NomeDoCampo: translate(returnedField.label),
        };
      },
      $MA039: (data) => {
        const returnedField = lossesFieldsDefinitions[data.field];
        if (!returnedField) return null;

        return {
          field: translate(returnedField.label),
        };
      },
    },
  },
};

export default {
  getLosses(assetId) {
    const http = new Http({
      errorHandling: {
        ignore: errorData => errorData.response.data.codigoMensagem === 'MSIS128',
      },
    });

    return http
      .get(urls.getLosses(assetId))
      .then(({ data }) => new Loss(data));
  },
  updateLosses(payload, assetId) {
    const mappedPayload = new Loss.MapBack(payload);
    const http = new Http(error);
    return http
      .put(urls.updateLosses(assetId), mappedPayload)
      .then(({ data }) => data);
  },
  calculateLosses(payload, assetId) {
    const mappedPayload = new LossCalculationRequest(payload);
    const http = new Http(error);
    return http
      .post(urls.calculateLosses(assetId), mappedPayload)
      .then(({ data }) => new Loss(data));
  },
};
